<template>
  <transition name="slide-fadeOut">
    <div class="tips" v-if="tipsBool">
      <div class="center">
        <p
          class="tips-content"
        >为响应国家政策，使用互联网服务需要进行帐号实名认证。为保障“评论”等功能的正常使用，请您注册完后，尽快到安全中心位置进行实名认证。</p>
        <i class="icon" @click="tipsBool=false"></i>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "tips",
  components: {},
  data() {
    return {
        tipsBool:true
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  beforeCreate() {}
};
</script>
<style lang='scss' scoped>
//过度
.slide-fadeOut-leave-active {
  transition: all 0.4s ease;
}
.slide-fadeOut-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(100px);
  opacity: 0;
}
.tips {
    z-index: 1000;
  height: 30px;
  width: 100%;
  background-color: #fff8c7;
  position: absolute;
  top: 160px;
  left: 0;
  .center {
    width: 1000px;
    margin: 0 auto;
    position: relative;
    .tips-content {
      color: #4c4c4c;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      letter-spacing: 0px;
      text-align: left;
      line-height: 30px;
    }
    .icon {
      width: 22px;
      height: 22px;
      display: inline-block;
      background: url("../../assets/images/icons.png") no-repeat -347px -46px;
      position: absolute;
      right: 0;
      top: 4px;
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/tips.vue